/**
 * Dependencies.
 */
import { useState } from "react";
import { createElement as el, Fragment as frag } from "@wordpress/element";
import PanelBody from "../PanelBody/PanelBody";
import LanguageButton from "../LanguageButton/LanguageButton";
import "./languageSwitcher.css";

/**
 * Provides a general element LanguageSwitcher.
 *
 * @returns {element} LanguageSwitcher.
 */
const LanguageSwitcher: React.FC = () => {
  const [panelOpened, setPanelOpened] = useState(false);

  const onMouseLeave = (evnt: any) => {
    setTimeout(() => {
      setPanelOpened(false);
    }, 200);
  };

  const onButtonClick = () => {
    setPanelOpened(!panelOpened);
  };

  const Switcher = () => {
    return el(
      frag,
      {},
      <LanguageButton onClick={() => onButtonClick()} />,
      <PanelBody
        open={panelOpened}
        onMouseLeave={(e: any) => onMouseLeave(e)}
      />
    );
  };
  return <Switcher />;
};

export default LanguageSwitcher;
